import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";

function EvaluationType() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      id: 0,
      name: "",
      createdBy: localStorage.getItem("userId"),
      organizationId: organizationId,
    },
  });

  const [evaluationType, setEvaluationType] = useState([]);
  const fetchEvaluationType = async () => {
    try {
      const response = await get(
        `StudentEvaluation/GetAllEvaluationType?organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setEvaluationType(response.evaluationTypes);
    } catch (error) {
      console.error("Error fetching subject:", error);
    }
  };
  useEffect(() => {
    fetchEvaluationType();
  }, [triggerRerender]);

  const filteredEvaluationType = evaluationType.filter((type) =>
    type.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Type",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Is Exam",
      selector: (row) => row.isExam,
      cell: (row) => (
        <input
          type="checkbox"
          checked={row.isExam}
          readOnly // Makes the checkbox non-interactive
        />
      ),
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="d-flex gap-1">
          <button
            type="button"
            className="btn p-0"
            onClick={() => handleEditClick(row.id)}
          >
            <i className="fas fa-pencil"></i>
          </button>
          <button
            type="button"
            className="btn p-0"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const handleEditClick = async (rowId) => {
    const response = await get(
      `StudentEvaluation/GetEvaluatinTypeById?id=${rowId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const evaluationType = response.evalutionType;

    reset({
      id: evaluationType.id,
      name: evaluationType.name,
      organizationId: evaluationType.organizationId,
      statusId: evaluationType.statusId,
      isExam: evaluationType.isExam,
      createdBy: evaluationType.createdBy,
      updatedBy: localStorage.getItem("userId"),
    });
  };
  const handleDeleteClick = async (rowId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Evaluation Type?"
    );

    if (confirmDelete) {
      try {
        const response = await get(
          `StudentEvaluation/DeleteEvaluationTypeById?id=${rowId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        fetchEvaluationType();
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    }
  };
  const saveData = async (data) => {
    data.statusId = 1;
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post(
        "StudentEvaluation/AddUpdateEvaluationAsync",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        reset({
          id: 0,
          name: "",
          organizationId: organizationId,
          code: "",
          isExam: false,
          createdBy: localStorage.getItem("userId"),
          updatedBy: localStorage.getItem("userId"),
        });
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Evaluation Type</h2>
      </div>
      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-2">
                <div className="col-md-4">
                  <label className="form-label">
                    Evaluation Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`name`, {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("name")}
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </div>
                <div className="col-md-4"></div>
                <div className="col-md-4">
                  <label className="form-label">Is Exam</label>
                  <input {...register(`isExam`)} type="checkbox" />
                </div>
                <div className="col-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div
                className="d-flex justify-content-end"
                style={{ marginTop: 0 }}
              >
                <div className="d-flex align-items-start gap-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "200px" }}
                  />
                </div>
              </div>
              <DataTable
                columns={columns}
                data={filteredEvaluationType}
                pagination
                dense
                customStyles={customTableStyles}
                highlightOnHover={true}
                onChangePage={setCurrentPage}
                onChangeRowsPerPage={setRowsPerPage}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default EvaluationType;
